import randomHashGenerator from "../helpers/randomHashGenerator";
const ROBOT_SESSIONS = "robotSessions";
const VISITED_SCREENS = "visitedScreens";
const SESSION = "session-";
export const sessionTitleBuilder = (sessionId) => {
    return SESSION + sessionId;
};
export const robotSessionsUrlBuilder = (appSessionId, robotSessionId) => {
    return SESSION + appSessionId + "/" + ROBOT_SESSIONS + "/" + SESSION + robotSessionId;
};
export const visitedScreensUrlBuilder = (appSessionId, screen) => {
    const screenUniqueId = randomHashGenerator(10);
    return SESSION + appSessionId + "/" + VISITED_SCREENS + "/" + screen + "-" + screenUniqueId;
};
